// ------------- import xternal dependencies ------------
import { StateCreator } from "zustand";

// ----------- import internal dependencies -----------
import { UserSliceType } from "./type";
import { addToResetFnsSet } from "./store";

/**
 * user state slice
 */
const sliceInitialState = {
  user: null,
  accessToken: null,
  facilities: null,
  roles: null,
  mode: {},
  selectedId: null,
  selectedUser: null,
  userFacilities: [],
  selectedUserFacilities: [],
  loggedinUserImage: "",
  userFacilityNames: [],
  userIncidentTypes: [],
  userIncidentStatus: [],
  attachments: [],
  fromDraft: false,
};
const createUserSlice: StateCreator<UserSliceType> = (set) => {
  const reset = () => set(sliceInitialState);
  addToResetFnsSet(reset);
  return {
    ...sliceInitialState,
    updateUser: (user: any) =>
      set(() => {
        return { user };
      }),
    updateAccessToken: (accessToken: any) =>
      set(() => {
        return {
          accessToken,
        };
      }),
    setSelectedId: (selectedId: any) =>
      set(() => {
        return {
          selectedId,
        };
      }),
    setSelectedUser: (selectedUser: any) =>
      set(() => {
        return {
          selectedUser,
        };
      }),
    setRoles: (roles: any) =>
      set(() => {
        return {
          roles,
        };
      }),
    setMode: (mode: any) =>
      set(() => {
        return { mode };
      }),
    setUserFacilities: (userFacilities: any) =>
      set(() => {
        return {
          userFacilities,
        };
      }),
    setSelectedUserFacilities: (selectedUserFacilities: any) =>
      set(() => {
        return {
          selectedUserFacilities,
        };
      }),
    setLoggedinUserImage: (loggedinUserImage: any) =>
      set(() => {
        return {
          loggedinUserImage,
        };
      }),
    setUserFacilityNames: (userFacilityNames: any) =>
      set(() => {
        return {
          userFacilityNames,
        };
      }),
    setUserIncidentTypes: (userIncidentTypes: any) =>
      set(() => {
        return { userIncidentTypes };
      }),
    setUserIncidentStatus: (userIncidentStatus: any) =>
      set(() => {
        return { userIncidentStatus };
      }),
    setAttachments: (attachments: any) =>
      set(() => {
        return { attachments };
      }),
    setFromDraft: (fromDraft: any) =>
      set(() => {
        return { fromDraft };
      }),
    resetUser: reset,
  };
};

export default createUserSlice;
